let navItem = document.querySelectorAll(".navigation__screen--innerMenu li a.nav-link.dropdown-toggle");
let innerMenu = document.querySelector(".navigation__screen--innerMenu .inner-menu");
let subMenus = document.querySelectorAll(".navigation__screen--innerMenu .sub-menu");
let backMain = document.querySelectorAll(".navigation__screen--innerMenu .back-main .nav-link");
[...navItem].forEach(item => {
    item.addEventListener("click", function(e) {
        e.preventDefault();
        let current = item.getAttribute("data-dropdowntarget");
        innerMenu.classList.add('collapse');
        [...subMenus].forEach(submenu => {
            if(submenu.classList.contains(`sub-menu-${current}`)) {
                submenu.classList.remove('collapse');
            } else {
                submenu.classList.add('collapse');
            }
        });
    });
});

[...backMain].forEach(item => {
    item.addEventListener("click", function(e) {
        e.preventDefault();
        innerMenu.classList.remove('collapse');
        [...subMenus].forEach(submenu => {
            submenu.classList.add("collapse");
        });
    });
});

